import ReportStudent from '@/shared/http/repositories/socialProject/report-student'
import VueHighcharts from 'vue2-highcharts'
import { loading } from '@/shared/utils/UIHelper'

export default {
  components: {
    VueHighcharts
  },
  data () {
    return {
      criteria: {
        socialEntityId: null
      },

      options: {
        chart: {
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 45
          },
          height: '800px'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            events: {
              click: this.LoadStudents
            },
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}'
            }
          },
          pie: {
            innerSize: 100,
            depth: 45
          }
        },
        series: []
      }
    }
  },
  mounted () {
    loading.push()
    ReportStudent.GetTotalBySocialProject()
      .then(response => {
        let itemArr = []
        let dataArr = []
        var totalStudentsInProject = 0
        let result = response.data.result

        result.forEach(item => {
          itemArr = { 'name': `${item.name}`, 'y': item.count, 'id': item.id }
          dataArr.push(itemArr)
          totalStudentsInProject += item.count
        })

        let chartData = [
          {
            name: 'Número de Alunos',
            data: dataArr,
            colorByPoint: true,
            colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1']
          }
        ]

        setTimeout(() => {
          this.$refs.pieChart.removeSeries(1)
          this.$refs.pieChart.addSeries(chartData[0])

          this.$emit('totalStudentsInProject', totalStudentsInProject)
          loading.pop()
        }, 2000)
      })
      .catch(e => {
        console.log(`Erro ao tentar obter os dados para o gráfico "Alunos Por Projeto Social": \n ${e}`)
      })
  },
  methods: {
    LoadStudents (e) {
      this.criteria.socialEntityId = e.point.id
      loading.push()
      ReportStudent.GetTotalBySocialProjectId(this.criteria)
        .then(response => {
          this.$emit('selectSocialProject', response.data.data)
          loading.pop()
        })
        .catch(e => {
          console.log(`Erro ao tentar obter os dados para o gráfico "Alunos Por Projeto Social": \n ${e}`)
        })
    }
  }
}
